import styled, { css } from 'styled-components'
import {
  BORDER_GRAY,
  HEADER_GRAY,
  PRIMARY_TEXT,
  BACKGROUND_REDESIGN,
  ICON_GREY,
} from 'constants/colors'
import { Flex, truncateStyles } from 'components/common/styles'
import { StyledSelectInput } from 'components/common/Inputs/styles'

export const ConditionalLogicContainer = styled.div`
  border-radius: 8px;
  border: 1px solid ${BORDER_GRAY};
  padding: 16px;
  color: ${PRIMARY_TEXT};

  ${StyledSelectInput} {
    .MuiFormControl-root {
      max-width: 100%;
    }
  }
`

export const ConditionalLogicHeader = styled.div`
  color: ${HEADER_GRAY};
  font-size: 16px;
  font-weight: 500;
  line-height: 140%;
  margin-bottom: 10px;
`

export const ModalTitle = styled(Flex)`
  height: 16px;
`

export const Description = styled.div`
  text-transform: none;
  margin-left: 8px;

  ${truncateStyles};
`

export const IconButtonContainer = styled.div`
  margin-left: 8px;
`

export const SelectedConditionalBlock = styled(Flex)`
  padding: 16px;
  border-radius: 12px;
  background: ${BACKGROUND_REDESIGN};
  margin-bottom: 10px;

  > div {
    max-width: calc(100% - 100px);
  }
`

export const Operator = styled.div`
  font-size: 17px;
  font-weight: 500;
  line-height: 24px;
  color: ${PRIMARY_TEXT};
`

export const ConditionRow = styled.div<{ marginLeft?: number }>`
  line-height: 24px;
  width: 100%;
  ${({ marginLeft }) =>
    marginLeft &&
    css`
      margin-left: ${marginLeft || 8}px;
    `}

  ${truncateStyles};
`

export const IconsContainer = styled.div`
  button {
    padding: 10px;
  }

  img {
    height: 14px;
    width: 14px;
    color: ${PRIMARY_TEXT};
    fill: ${PRIMARY_TEXT};
    stroke: ${ICON_GREY};
  }
`

export const SelectContainer = styled.div`
  .MuiFormControl-root {
    width: 190px;
    max-width: 190px;
  }
`

export const CriteriaContainer = styled.div`
  margin-left: 8px;
`
